import '@vueform/vueform/themes/tailwind/'

export default defineNuxtPlugin(() => {
  // O módulo @vueform/nuxt já registra o plugin usando vueform.config.ts.
  // Este arquivo permanece apenas para carregar o tema uma única vez no client.
})
